import React from 'react'

export default class Blank extends React.Component {
  render(){
    return (
      <div style={{margin: "0 auto", padding: 50}}></div>
    )
  }
}